import {
  TealiumEventPlayerGroup,
  IGetEventGroupProps,
  tealiumEventPlayerGroupPrefix,
  PlayerCasting,
  TealiumEventPlayerGroupCC,
  PlayerStatus,
  PlayerForm,
  ActivePodcastOrStation,
} from '@4tn/core-audio-player-shared';

export class TealiumEventPlayer implements IGetEventGroupProps {
  private player_autoplay = false;

  private readonly player_casting: boolean | PlayerCasting = TealiumEventPlayer.detectCasting();

  private player_channel: string | null = null;

  private player_channelid: string | null = null;

  private readonly player_embedurl? = window?.location.href;

  private player_fullscreen = false;

  private player_width: number | null = null;

  private player_height: number | null = null;

  private player_id: string | null = null;

  private player_state: PlayerStatus | null = null;

  private readonly player_engine = 'html';

  private player_version: string | null = null;

  private player_form: PlayerForm | null = PlayerForm.NORMAL_PLAYER;

  constructor({
    playerAutoplay,
    playerChannel,
    playerChannelid,
    playerFullscreen,
    playerWidth,
    playerHeight,
    playerId,
    playerState,
    playerVersion,
    playerForm,
  }: TealiumEventPlayerGroupCC) {
    if (playerAutoplay) {
      this.player_autoplay = playerAutoplay;
    }
    if (playerChannel) {
      this.player_channel = playerChannel;
    }
    if (playerChannelid) {
      this.player_channelid = playerChannelid;
    }
    if (playerFullscreen) {
      this.player_fullscreen = playerFullscreen;
    }
    if (playerWidth) {
      this.player_width = playerWidth;
    }
    if (playerHeight) {
      this.player_height = playerHeight;
    }
    if (playerId) {
      this.player_id = playerId;
    }
    if (playerState) {
      this.player_state = playerState;
    }
    if (playerVersion) {
      this.player_version = playerVersion;
    }
    if (playerForm) {
      this.player_form = playerForm;
    }
  }

  public getEventGroupProps(): TealiumEventPlayerGroup {
    const groupKeys = Object.keys(this).filter((k) => k.startsWith(tealiumEventPlayerGroupPrefix));
    const eventGroupProps = groupKeys.reduce((o, k) => Object.assign(o, { [k]: this[k] }), {});
    return eventGroupProps as TealiumEventPlayerGroup;
  }

  private static detectCasting(): boolean | PlayerCasting {
    const castDevices = ['crkey', 'apple tv', 'tv', 'avhttp', 'heos', 'carplay'];
    const userAgent = navigator.userAgent.toLowerCase();

    for (let i = 0; i < castDevices.length; i++) {
      if (userAgent.indexOf(castDevices[i]) !== -1) {
        switch (castDevices[i]) {
          case castDevices[0]:
            return PlayerCasting.CHROMECAST;
          case castDevices[1]:
            return PlayerCasting.AIRPLAY;
          case castDevices[3]:
            return PlayerCasting.AIRPLAY;
          case castDevices[4]:
            return PlayerCasting.HEOS;
          case castDevices[5]:
            return PlayerCasting.CARPLAY;
          default:
            return true;
        }
      }
    }
    return false;
  }

  /**
   * the parseMediaMetadata function sets values for the list of props:
   * player_channel,
   * player_channelid,
   * */
  public parseMediaMetadata(mediaMetadata: ActivePodcastOrStation) {
    const { title, slug, media } = mediaMetadata;
    this.player_channel = title || slug || null;
    if (media) {
      this.player_channelid = media[0]?.uri || null;
    }
  }
}
